import { render } from "./App.vue?vue&type=template&id=2fa23adf&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2fa23adf&lang=css&scoped=true"

import exportComponent from "/var/www/test.mciafc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa23adf"]])

export default __exports__